import { render, staticRenderFns } from "./Integral.vue?vue&type=template&id=3ed3d85e&scoped=true&"
import script from "./Integral.vue?vue&type=script&lang=js&"
export * from "./Integral.vue?vue&type=script&lang=js&"
import style0 from "./Integral.vue?vue&type=style&index=0&id=3ed3d85e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed3d85e",
  null
  
)

export default component.exports